<template>
  <div
    class="is-circle"
    :class="{
      'is-selected': isSelected,
      'is-scaled': scaleOnSelect && isSelected,
      }"
    :style="{
      'background-image': option.fillImage ? `url(${option.fillImage})` : '',
      'background-repeat': 'round',
      'background-color': option.fillColor ? `${option.fillColor}` : ''
    }"
  >
    <img
      v-if="option.icon"
      :src="option.icon"
    >
  </div>
</template>

<script>
  // TODO rename
  export default {
    name: "CircleSelect",
    props: ["option", "scaleOnSelect", "isSelected"]
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  .is-circle {
    position: relative;
    height: 3em;
    width: 3em;
    padding: 0.25em;
    border-radius: 50%;
    border: 1px solid white;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .is-selected {
    border: 0.2em solid $primary;
  }

  .is-scaled {
    transform: scale(1.5);
  }
</style>
